<template>
  <v-application v-if="access.inv_purchase_orders">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="purchase"
          to="/purchase/employee"
          v-bind:num-pages="purchases_total"
          v-model="currentPage"
          v-bind:headers="headers"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_purchase_employee'"
          v-bind:data="purchases"
          view
          no-delete
          showSearch
          InventoryPurchaseEmployee
          v-bind:search_text="search_text"
          v-bind:getData="update_purchase_employees"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-combobox
              outlined
              dense
              v-model="status"
              label="Status"
              v-bind:items="em_statusses"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              outlined
              dense
              v-model="store"
              label="Store"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              item-text="name"
              hide-details
              label="Employe"
              v-model="employee"
              v-bind:items="all_employees_"
              prepend-inner-icon="mdi-account"
              clear-icon="mx-1"
              outlined
              dense
            />
            <!-- <v-btn icon @click="download_dialog = true">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->
          </template>
        </v-crud-card>
        <v-dialog v-model="download_dialog" max-width="800px" persistent>
          <v-card>
            <v-card-title>Download purchases</v-card-title>
            <v-row no-gutters class="mx-4">
              <v-col>
                <data-picker
                  v-model="download_start"
                  class="pa-2"
                  style="width: 100%"
                  placeholder="Start date"
                  :type="'datetime'"
                  format="DD-MM-YYYY HH:mm"
                  :showSecond="false"
                />
              </v-col>
              <v-col>
                <data-picker
                  v-model="download_end"
                  class="pa-2"
                  style="width: 100%"
                  placeholder="Start date"
                  :type="'datetime'"
                  format="DD-MM-YYYY HH:mm"
                  :showSecond="false"
                />
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="secondary" @click="downloadCancel">
                Cancel
              </v-btn>

              <v-btn
                text
                color="primary"
                @click="downloadCancel"
                :disabled="downPurchases.length == 0"
              >
                <export-excel
                  :data="downPurchases"
                  :name="excel_name"
                  v-html="'Save Excel'"
                />
                <!--:fields="my_Fields"-->
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Purchases from "../../mixins/inventory/purchase";
import Suppliers from "../../mixins/inventory/supplier";
import Services from "../../mixins/services";
import Emplooyes from "../../mixins/employees/workgroup";
import DataPicker from "vue2-datepicker";

const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  name: "InventoryPurchaseEmployee",
  mixins: [Purchases, Services, AllSuppliers, Emplooyes],
  components: {
    DataPicker,
  },
  data: () => ({
    page: 1,
    employee: null,
    store: null,
    data: [],
    search_text: false,
    search: "",
    download_dialog: false,
    download_start: null,
    download_end: null,
    downPurchases: [],
    excel_name: "Internal orders",
  }),
  methods: {
    changePagination(page) {
      this.$store.commit("purchaseOrder/updatePagination", page);
      this.update_purchase_employees(this.params);
    },
    defaultvalue() {
      this.employee = this.all_employees_[0].name;
    },
    async downloadPurchases() {
      this.data_loading = true;
      const downPurchases = this.$communicator.then(
        this,
        await this.$communicator("purchase_employees", {
          params: {
            limit: 9999999,
            page: 1,
            min: new Date(this.download_start).getTime(),
            max: new Date(this.download_end).getTime(),
            service: this.store._id,
            status: this.status.value,
            search: this.search,
            employee_id: this.employee._id,
          },
        })
      );
      if (downPurchases) {
        this.downPurchases = downPurchases.data.map((pur) => ({
          p_order: pur.p_order,
          date: this.date_ddmmyy(pur.date),
          employee_name: pur.employee_name,
          store: pur.service_name,
          status: pur.status.toUpperCase(),
        }));

        this.data_loading = false;
      }
    },
    downloadCancel() {
      this.download_dialog = false;
      this.download_start = null;
      this.download_end = null;
      this.downPurchases = [];
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
    this.store = this.$store.state.items_current_service;
  },
  computed: {
    currentPage: {
      get() {
        return this.$store.state.purchaseOrder.page;
      },
      set(val) {
        this.$store.commit("purchaseOrder/updatePagination", val);
      },
    },
    headers() {
      let headers = [
        { text: this.$t("purchase_order"), value: "p_order" , available: true},
        { text: this.$t("date"), value: "date", available: true },
        { text: this.$t("employee_name"), value: "employee_name" , available: true},
        { text: this.$t("store"), value: "service_name" , available: true},
        { text: this.$t("status"), value: "status", available: true },
        { value: "items_count", available: true },
      ];
      return headers;
    },
    my_Fields() {
      const down_headers = {
        "Purchase order": "p_order",
        Date: "date",
        "Employee name": "employee_name",
        Store: "service_name",
        Status: "status",
      };
      return down_headers;
    },
  },
  created() {
    this.defaultvalue();
  },
  mounted() {
    this.defaultvalue();
  },
  watch: {
    employee: {
      deep: true,
      handler() {
        this.update_purchase_employees();
      },
    },
    store: {
      deep: true,
      handler() {
        this.$store.commit("setItemsService", this.store);
        this.update_purchase_employees();
      },
    },
    supplier: {
      deep: true,
      handler() {
        this.$store.commit("setSupplier", this.supplier);
        this.update_purchase_employees();
      },
    },
    type: {
      deep: true,
      handler() {
        this.$store.commit("setType", this.type);
        this.update_purchase_employees();
      },
    },
    status: {
      deep: true,
      handler() {
        this.update_purchase_employees();
      },
    },
    download_start() {
      if (this.download_end !== null && this.download_start !== null) {
        this.downloadPurchases();
      }
    },
    download_end() {
      if (this.download_end !== null && this.download_start !== null) {
        this.downloadPurchases();
      }
    },
  },
};
</script>
<style></style>
